import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const CARDS = [
  {
    icon: 'solar:phone-calling-bold',
    iconColor: 'text-brand-400',
    bg: 'bg-brand-400/15',
    glowColor: 'rgba(253,205,39,0.08)',
    title: '365일 24시간 상담',
    desc: '새벽이든, 주말이든 언제 연락하셔도 바로 응답합니다. 매장 운영 중 문제가 생기면 즉시 해결해 드립니다.',
    metricVal: '1분',
    metricLabel: '평균 응답 시간',
    highlight: '365일 24시간',
    hlColor: 'text-brand-400',
  },
  {
    icon: 'solar:map-point-bold',
    iconColor: 'text-blue-400',
    bg: 'bg-blue-500/15',
    glowColor: 'rgba(59,130,246,0.08)',
    title: '전국 출장 지원',
    desc: '전국 어디든 직접 방문하여 설치부터 교육까지 원스톱으로 진행합니다.',
    metricVal: '전국',
    metricLabel: '출장 지원 범위',
    highlight: '설치부터 교육까지',
    hlColor: 'text-blue-400',
  },
  {
    icon: 'solar:chat-round-dots-bold',
    iconColor: 'text-emerald-400',
    bg: 'bg-emerald-500/15',
    glowColor: 'rgba(16,185,129,0.08)',
    title: '카카오톡 실시간 상담',
    desc: '카카오톡 채널을 추가하시면 채팅으로 편하게 문의하실 수 있습니다. 사진 한 장이면 문제 해결.',
    metricVal: '채팅',
    metricLabel: '카카오톡 상담',
    highlight: '카카오 채널에서 바로 상담',
    hlColor: 'text-emerald-400',
    link: 'http://pf.kakao.com/_fgiMX/chat',
  },
];

export default function Support() {
  return (
    <section className="py-28 lg:py-40 bg-neutral-950 text-white relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-brand-400/3 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <RevealWrap className="text-center max-w-2xl mx-auto mb-20">
          <p className="text-brand-400 font-semibold text-sm tracking-wide uppercase mb-3">Support</p>
          <h2 className="text-3xl lg:text-5xl font-bold leading-tight tracking-tight mb-4">
            365일, 24시간<br />항상 함께합니다
          </h2>
          <p className="text-neutral-400 text-lg leading-relaxed">
            영업 중 문제가 생기면 1분 내로 해결해 드립니다.
          </p>
        </RevealWrap>

        <div className="grid md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => (
            <RevealWrap key={c.title} animation={i === 0 ? 'left' : i === 2 ? 'right' : 'scale'} className={i > 0 ? `reveal-delay-${i}` : ''}>
              <div className="bezel-card p-1 h-full group">
                <div className="bezel-card-inner p-8 lg:p-10 h-full relative overflow-hidden">
                  <div
                    className="absolute -top-20 -right-20 w-48 h-48 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"
                    style={{ background: c.glowColor }}
                  />
                  <div className="relative z-10 text-center">
                    <div className={`w-16 h-16 rounded-2xl ${c.bg} flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-500`}>
                      <Icon icon={c.icon} className={`${c.iconColor} text-3xl`} />
                    </div>
                    <h3 className="text-2xl font-bold mb-3 text-white">{c.title}</h3>
                    <p className="text-neutral-400 leading-relaxed mb-6 text-base">{c.desc}</p>

                    <div className="bg-white/5 rounded-2xl p-5 border border-white/5 mb-5">
                      <p className="text-3xl font-bold text-white mb-1">{c.metricVal}</p>
                      <p className="text-neutral-500 text-sm">{c.metricLabel}</p>
                    </div>

                    {c.link ? (
                      <a href={c.link} target="_blank" rel="noopener noreferrer" className={`${c.hlColor} font-bold text-sm hover:underline inline-flex items-center gap-1`}>
                        {c.highlight}
                        <Icon icon="solar:arrow-right-up-linear" className="text-base" />
                      </a>
                    ) : (
                      <p className={`${c.hlColor} font-bold text-sm`}>{c.highlight}</p>
                    )}
                  </div>
                </div>
              </div>
            </RevealWrap>
          ))}
        </div>
      </div>
    </section>
  );
}
